import React from 'react';
import { Container } from './RequiredAsterisk.styles';

const RequiredAsterisk = () => <Container>*</Container>;

export default RequiredAsterisk;
